import { render, staticRenderFns } from "./TestDetailsAllIndiaMockTest.vue?vue&type=template&id=108732c2"
import script from "./TestDetailsAllIndiaMockTest.vue?vue&type=script&lang=js"
export * from "./TestDetailsAllIndiaMockTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports